import React, { useState, useEffect } from "react";

import {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
} from "chart.js";
// import { Chart as ChartJS } from "chart.js/auto";
import { Doughnut, Bar, Line, Scatter, Pie } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import GlobalDiamondReportService from "../../services/reports-globalDiamond-service";

import { useSelector } from "react-redux";
import moment from "moment";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  Table,
  Tooltip,
} from "antd";
import Chart from "react-google-charts";
import { chartColors } from "../reports/colors";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DiamondShapeComp = ({ globalDiamonds, isApplyFilter, mainForDealer }) => {
  const { t } = useTranslation();
  /*React Binding Starts*/
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const loginDetials = useSelector((state) => state.loginReducer);
  const [diamondShapeSearchesLabels, setDiamondShapeSearchesLabels] = useState(
    []
  );
  const [DiamondShapeSearchesList, setDiamondShapeSearchesList] = useState([]);
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [DiamondShapeColorData, setDiamondShapeColorData] = useState([]);
  const [DiamondShapeYAxisList, setDiamondShapeYAxisList] = useState([]);
  const [key, setKey] = useState(true);
  /*React Binding Ends*/

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          // handleCheckDealermembers(loginDetials.loginDetials.responseData.dealerId);
          handleLoadChartReports(
            loginDetials.loginDetials.responseData.dealerId,
            mainForDealer
          );
        }
      }
    }
  }, [isApplyFilter]);

  /*API Binding Starts*/
  const handleCheckDealermembers = (id) => {
    try {
      let inputData = {
        dealerID: id,
      };

      GlobalDiamondReportService.CheckDealermembers(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var forDealer = responseData.forDealer;
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setForDealer(forDealer);
            } else {
              setForDealer("");
            }
            // handleDiamondChartForCutGrade(id, forDealer);
            handleLoadChartReports(id, forDealer);
          } else {
            setForDealer("");
          }
        })
        .catch((error) => {
          setForDealer("");
        });
    } catch (error) {
      setForDealer("");
    }
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        // "fromDate": "2020-08-17",
        // "toDate": "2022-09-15",
        retailerIds: globalDiamonds.retailerIds.toString(),
        vendorIds: globalDiamonds.vendorIds.toString(),
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        type: "",
        reportName: "ExtDiamondChrt",
      };
      setLoadChartReportsLoading(true);

      GlobalDiamondReportService.LoadChartReports(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          var TotalDiamondClicks =
            responseData.TotalDiamondClicks[0].TotalClickCnt;
          var DiamondShapeSearchesList = responseData.DiamondShapeSearches;
          setLoadChartReportsLoading(false);
          if (message === "Success") {
            if (Object.keys(responseData).length !== 0) {
              setTotalDiamondClicks(TotalDiamondClicks);
              setDiamondShapeSearchesList(DiamondShapeSearchesList);
              var DiamondShapeSearchesLabelArr = DiamondShapeSearchesList.map(
                (item) => {
                  return item.Cut;
                }
              );
              var DiamondShapeYAxisList = DiamondShapeSearchesList.map(
                (item) => {
                  return parseInt(item.CNT) || 0;
                }
              );
              var DiamondShapeColorList = DiamondShapeSearchesList.map(
                (item) => {
                  return item.Cut;
                }
              );
              setDiamondShapeSearchesLabels(DiamondShapeSearchesLabelArr);
              setDiamondShapeYAxisList(DiamondShapeYAxisList);
              diamondShapeColorHandler(DiamondShapeSearchesLabelArr);
              setKey(!key);
            }
          } else {
            setTotalDiamondClicks([]);
            setDiamondShapeSearchesList([]);
            setDiamondShapeYAxisList([]);
          }
        })
        .catch((error) => {
          setDiamondShapeSearchesList([]);
          setLoadChartReportsLoading(false);
          setDiamondShapeYAxisList([]);
          setDiamondShapeSearchesLabels([]);
          setTotalDiamondClicks([]);
        });
    } catch (error) {
      setDiamondShapeSearchesList([]);
      setLoadChartReportsLoading(false);
      setDiamondShapeYAxisList([]);
      setDiamondShapeSearchesLabels([]);
      setTotalDiamondClicks([]);
    }
  };
  /*API Binding Ends*/

  const diamondShapeColorHandler = (list) => {
    const colors = list.map(
      (_, index) => chartColors[index % chartColors.length]
    );
    setDiamondShapeColorData(colors);
  };
  const handleShapeKey = (count) => {
    const myData = DiamondShapeYAxisList;
  };

  const chartData = [
    ["Shape", {type: "number", label: "Count"}, { role: "style" }, {type: "string", role: "annotation" }],
    ...diamondShapeSearchesLabels?.map((label, index) => {
      const value = parseInt(DiamondShapeYAxisList[index]) || 0;
      const color = DiamondShapeColorData[index] || "#4285F4";
      return [label, value, color, String(value)];
    }),
  ];

  const options = {
    legend: { position: "none" },
    bar: { groupWidth: "40%" },
    chartArea: { left: 40, top: 80, bottom: 70, width: "90%", height: "80%" },
    hAxis: {
      title: "Shape",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    vAxis: {
      title: "Count",
      textStyle: { fontSize: 18, bold: true, color: "#424242" },
      titleTextStyle: { color: "rgb(66, 66, 66)", fontSize: 22, bold: true },
    },
    annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 16,
        bold: true,
        color: "#000",
      },
    },
  };

  return (
    <React.Fragment>
      <div className="col-lg-12 mt-4">
        <label>
          <b> {t("Diamond Shape Searches")} </b>
        </label>
        <div className="chart__section">
          <Spin spinning={LoadChartReportsLoading} size="large">
            {/* <Bar
              key={key}
              data={{
                labels: diamondShapeSearchesLabels,
                datasets: [
                  {
                    label: "Count",
                    data: DiamondShapeYAxisList,
                    backgroundColor: DiamondShapeColorData,
                    borderColor: DiamondShapeColorData,
                    borderWidth: 1,
                  },
                ],
              }}
              width={300}
              height={300}
              options={{
                scales: {
                  x: {
                    title: {
                      color: "rgb(66, 66, 66)",
                      display: true,
                      text: "Shape",
                      font: {
                        size: 16,
                      },
                    },
                  },
                },
                maintainAspectRatio: false,
                responsive: true,
                onClick: function (evt, element) {},
                plugins: {
                  datalabels: {
                    display: false,
                  },
                  legend: {
                    display: false,
                  },
                },
              }}
            /> */}
            <div id="pdf-content">
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                {diamondShapeSearchesLabels.map((label, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "0 10px",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    <div
                      style={{
                        width: "14px",
                        height: "14px",
                        backgroundColor: DiamondShapeColorData[index],
                        marginRight: "6px",
                      }}
                    ></div>
                    {label} ({DiamondShapeYAxisList[index]})
                  </div>
                ))}
              </div>
              <Chart
                chartType="ColumnChart"
                width={window.innerWidth > 500 ? "100%" : 300}
                height={window.innerWidth > 500 ? 600 : 300}
                data={chartData}
                options={options}
              />
            </div>
          </Spin>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondShapeComp;
